import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
      class: "w-full p-link flex align-items-center p-2 pl-4 text-color hover:surface-200 border-noround"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "material-icons icon-class pr-2" }, "logout", -1)
    ]))
  ]))
}